module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t("inviteSponsorView.viaEmail")))]), _vm._v(" "), _c('form', {
    staticClass: "field",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.inviteViaEmail()
      }
    }
  }, [_vm._l((_vm.sponsors), function(s, i) {
    return _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (s.email),
        expression: "s.email"
      }],
      key: i,
      attrs: {
        "type": "email",
        "placeholder": _vm.$t('inviteSponsorView.writeEmailAddress')
      },
      domProps: {
        "value": (s.email)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          s.email = $event.target.value
        }
      }
    })
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "borderless-button",
    on: {
      "click": function($event) {
        _vm.addRecipient()
      }
    }
  }, [_vm._v("\r\n                " + _vm._s(_vm.$t("inviteSponsorView.addRecipient")) + "\r\n            ")])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "button button-green",
    attrs: {
      "type": "submit",
      "disabled": !_vm.isValidatedForSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t("inviteSponsorView.sendInvitations")))])])], 2), _vm._v(" "), (_vm.status == 'Sending') ? _c('div', [_vm._v("\r\n        " + _vm._s(_vm.$t("inviteSponsorView.sendingInvitations ")) + "\r\n        "), _c('KkSpinner')], 1) : (_vm.status == 'Sent') ? _c('div', [_vm._v("\r\n        " + _vm._s(_vm.$t("inviteSponsorView.emailInvitationsSent")) + "\r\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('div', [(!_vm.sponsorCopied) ? _c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.copySponsorLink()
      }
    }
  }, [_vm._v("\r\n                " + _vm._s(_vm.$t("inviteSponsorView.copySponsorLink")) + "\r\n                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sponsorlink),
      expression: "sponsorlink"
    }],
    ref: "text",
    staticStyle: {
      "font-size": ".7em"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.sponsorlink)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sponsorlink = $event.target.value
      }
    }
  })]) : _c('button', {
    staticClass: "button button-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\r\n                " + _vm._s(_vm.$t("inviteSponsorView.copied")) + "\r\n            ")])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.invitePreviousSponsors
    }
  }, [_vm._v("\r\n                " + _vm._s(_vm.$t("inviteSponsorView.invitePreviousSponsors")) + "\r\n            ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a4e12358","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/ts/views/InviteSponsorView.vue
// module id = 127
// module chunks = 0